export { default as useSBSGetCompanyQuery } from './api/queries/use-sbs-get-company-query';
